export default __webpack_public_path__ + "static/media/OpelNext.866b2ddf.otf";